import Container from "components/Container";
import { useBreadcrumb } from "features/breadcrumbs";
import ListaRelatorioReservas from "./components/ListaRelatorioReservas/index";

function RelatorioReservas() {
  useBreadcrumb([
    { name: "Relatórios" },
    {
      name: "Reservas",
      url: "/relatorios/reservas",
    },
  ]);

  return (
    <Container>
      <ListaRelatorioReservas />
    </Container>
  );
}

export default RelatorioReservas;
